var cov_tx9pssfxo = function () {
  var path = "/Users/spana/SHEIN/shineout/src/hoc/inputBorder.tsx",
      hash = "84d83db2c82f92f6d2452d46cfb475d0aa7f59e2",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/hoc/inputBorder.tsx",
    statementMap: {
      "0": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 154,
          column: 58
        }
      },
      "1": {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 36,
          column: 20
        }
      },
      "2": {
        start: {
          line: 37,
          column: 8
        },
        end: {
          line: 37,
          column: 22
        }
      },
      "3": {
        start: {
          line: 38,
          column: 8
        },
        end: {
          line: 40,
          column: 9
        }
      },
      "4": {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 41,
          column: 46
        }
      },
      "5": {
        start: {
          line: 42,
          column: 8
        },
        end: {
          line: 42,
          column: 52
        }
      },
      "6": {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 43,
          column: 54
        }
      },
      "7": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 48,
          column: 20
        }
      },
      "8": {
        start: {
          line: 52,
          column: 8
        },
        end: {
          line: 52,
          column: 39
        }
      },
      "9": {
        start: {
          line: 53,
          column: 27
        },
        end: {
          line: 53,
          column: 37
        }
      },
      "10": {
        start: {
          line: 54,
          column: 8
        },
        end: {
          line: 54,
          column: 33
        }
      },
      "11": {
        start: {
          line: 54,
          column: 20
        },
        end: {
          line: 54,
          column: 33
        }
      },
      "12": {
        start: {
          line: 58,
          column: 8
        },
        end: {
          line: 58,
          column: 38
        }
      },
      "13": {
        start: {
          line: 59,
          column: 28
        },
        end: {
          line: 59,
          column: 38
        }
      },
      "14": {
        start: {
          line: 60,
          column: 8
        },
        end: {
          line: 60,
          column: 35
        }
      },
      "15": {
        start: {
          line: 60,
          column: 21
        },
        end: {
          line: 60,
          column: 35
        }
      },
      "16": {
        start: {
          line: 64,
          column: 75
        },
        end: {
          line: 64,
          column: 85
        }
      },
      "17": {
        start: {
          line: 65,
          column: 26
        },
        end: {
          line: 65,
          column: 39
        }
      },
      "18": {
        start: {
          line: 66,
          column: 25
        },
        end: {
          line: 66,
          column: 78
        }
      },
      "19": {
        start: {
          line: 69,
          column: 10
        },
        end: {
          line: 71,
          column: 87
        }
      },
      "20": {
        start: {
          line: 74,
          column: 8
        },
        end: {
          line: 88,
          column: 9
        }
      },
      "21": {
        start: {
          line: 75,
          column: 10
        },
        end: {
          line: 75,
          column: 50
        }
      },
      "22": {
        start: {
          line: 75,
          column: 21
        },
        end: {
          line: 75,
          column: 50
        }
      },
      "23": {
        start: {
          line: 76,
          column: 10
        },
        end: {
          line: 87,
          column: 11
        }
      },
      "24": {
        start: {
          line: 78,
          column: 39
        },
        end: {
          line: 78,
          column: 46
        }
      },
      "25": {
        start: {
          line: 89,
          column: 8
        },
        end: {
          line: 89,
          column: 19
        }
      },
      "26": {
        start: {
          line: 105,
          column: 12
        },
        end: {
          line: 105,
          column: 22
        }
      },
      "27": {
        start: {
          line: 106,
          column: 26
        },
        end: {
          line: 106,
          column: 36
        }
      },
      "28": {
        start: {
          line: 108,
          column: 20
        },
        end: {
          line: 108,
          column: 27
        }
      },
      "29": {
        start: {
          line: 110,
          column: 20
        },
        end: {
          line: 110,
          column: 42
        }
      },
      "30": {
        start: {
          line: 112,
          column: 25
        },
        end: {
          line: 112,
          column: 56
        }
      },
      "31": {
        start: {
          line: 113,
          column: 27
        },
        end: {
          line: 113,
          column: 90
        }
      },
      "32": {
        start: {
          line: 114,
          column: 29
        },
        end: {
          line: 133,
          column: 9
        }
      },
      "33": {
        start: {
          line: 135,
          column: 8
        },
        end: {
          line: 152,
          column: 9
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 25,
            column: 3
          },
          end: {
            line: 25,
            column: 4
          }
        },
        loc: {
          start: {
            line: 26,
            column: 4
          },
          end: {
            line: 154,
            column: 58
          }
        },
        line: 26
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 35,
            column: 7
          }
        },
        loc: {
          start: {
            line: 35,
            column: 43
          },
          end: {
            line: 45,
            column: 7
          }
        },
        line: 35
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 47,
            column: 6
          },
          end: {
            line: 47,
            column: 7
          }
        },
        loc: {
          start: {
            line: 47,
            column: 38
          },
          end: {
            line: 49,
            column: 7
          }
        },
        line: 47
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 51,
            column: 6
          },
          end: {
            line: 51,
            column: 7
          }
        },
        loc: {
          start: {
            line: 51,
            column: 55
          },
          end: {
            line: 55,
            column: 7
          }
        },
        line: 51
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 57,
            column: 6
          },
          end: {
            line: 57,
            column: 7
          }
        },
        loc: {
          start: {
            line: 57,
            column: 56
          },
          end: {
            line: 61,
            column: 7
          }
        },
        line: 57
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 63,
            column: 7
          }
        },
        loc: {
          start: {
            line: 63,
            column: 34
          },
          end: {
            line: 90,
            column: 7
          }
        },
        line: 63
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 78,
            column: 33
          },
          end: {
            line: 78,
            column: 34
          }
        },
        loc: {
          start: {
            line: 78,
            column: 39
          },
          end: {
            line: 78,
            column: 46
          }
        },
        line: 78
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 92,
            column: 7
          }
        },
        loc: {
          start: {
            line: 92,
            column: 15
          },
          end: {
            line: 153,
            column: 7
          }
        },
        line: 92
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 54,
            column: 33
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 54,
            column: 33
          }
        }, {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 54,
            column: 33
          }
        }],
        line: 54
      },
      "1": {
        loc: {
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 60,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 60,
            column: 35
          }
        }, {
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 60,
            column: 35
          }
        }],
        line: 60
      },
      "2": {
        loc: {
          start: {
            line: 64,
            column: 37
          },
          end: {
            line: 64,
            column: 70
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 64,
            column: 52
          },
          end: {
            line: 64,
            column: 70
          }
        }],
        line: 64
      },
      "3": {
        loc: {
          start: {
            line: 66,
            column: 25
          },
          end: {
            line: 66,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 66,
            column: 25
          },
          end: {
            line: 66,
            column: 32
          }
        }, {
          start: {
            line: 66,
            column: 37
          },
          end: {
            line: 66,
            column: 77
          }
        }],
        line: 66
      },
      "4": {
        loc: {
          start: {
            line: 66,
            column: 37
          },
          end: {
            line: 66,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 66,
            column: 47
          },
          end: {
            line: 66,
            column: 61
          }
        }, {
          start: {
            line: 66,
            column: 64
          },
          end: {
            line: 66,
            column: 77
          }
        }],
        line: 66
      },
      "5": {
        loc: {
          start: {
            line: 69,
            column: 10
          },
          end: {
            line: 71,
            column: 87
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 70,
            column: 14
          },
          end: {
            line: 70,
            column: 32
          }
        }, {
          start: {
            line: 71,
            column: 14
          },
          end: {
            line: 71,
            column: 87
          }
        }],
        line: 69
      },
      "6": {
        loc: {
          start: {
            line: 69,
            column: 10
          },
          end: {
            line: 69,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 69,
            column: 10
          },
          end: {
            line: 69,
            column: 28
          }
        }, {
          start: {
            line: 69,
            column: 32
          },
          end: {
            line: 69,
            column: 56
          }
        }],
        line: 69
      },
      "7": {
        loc: {
          start: {
            line: 71,
            column: 62
          },
          end: {
            line: 71,
            column: 86
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 71,
            column: 62
          },
          end: {
            line: 71,
            column: 80
          }
        }, {
          start: {
            line: 71,
            column: 84
          },
          end: {
            line: 71,
            column: 86
          }
        }],
        line: 71
      },
      "8": {
        loc: {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 88,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 88,
            column: 9
          }
        }, {
          start: {
            line: 74,
            column: 8
          },
          end: {
            line: 88,
            column: 9
          }
        }],
        line: 74
      },
      "9": {
        loc: {
          start: {
            line: 74,
            column: 12
          },
          end: {
            line: 74,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 13
          },
          end: {
            line: 74,
            column: 18
          }
        }, {
          start: {
            line: 74,
            column: 22
          },
          end: {
            line: 74,
            column: 29
          }
        }, {
          start: {
            line: 74,
            column: 35
          },
          end: {
            line: 74,
            column: 38
          }
        }, {
          start: {
            line: 74,
            column: 42
          },
          end: {
            line: 74,
            column: 47
          }
        }],
        line: 74
      },
      "10": {
        loc: {
          start: {
            line: 75,
            column: 10
          },
          end: {
            line: 75,
            column: 50
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 75,
            column: 10
          },
          end: {
            line: 75,
            column: 50
          }
        }, {
          start: {
            line: 75,
            column: 10
          },
          end: {
            line: 75,
            column: 50
          }
        }],
        line: 75
      },
      "11": {
        loc: {
          start: {
            line: 85,
            column: 15
          },
          end: {
            line: 85,
            column: 42
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 85,
            column: 23
          },
          end: {
            line: 85,
            column: 36
          }
        }, {
          start: {
            line: 85,
            column: 39
          },
          end: {
            line: 85,
            column: 42
          }
        }],
        line: 85
      },
      "12": {
        loc: {
          start: {
            line: 110,
            column: 20
          },
          end: {
            line: 110,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 110,
            column: 20
          },
          end: {
            line: 110,
            column: 31
          }
        }, {
          start: {
            line: 110,
            column: 35
          },
          end: {
            line: 110,
            column: 42
          }
        }],
        line: 110
      },
      "13": {
        loc: {
          start: {
            line: 113,
            column: 27
          },
          end: {
            line: 113,
            column: 90
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 113,
            column: 66
          },
          end: {
            line: 113,
            column: 71
          }
        }, {
          start: {
            line: 113,
            column: 74
          },
          end: {
            line: 113,
            column: 90
          }
        }],
        line: 113
      },
      "14": {
        loc: {
          start: {
            line: 115,
            column: 27
          },
          end: {
            line: 115,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 115,
            column: 27
          },
          end: {
            line: 115,
            column: 30
          }
        }, {
          start: {
            line: 115,
            column: 34
          },
          end: {
            line: 115,
            column: 39
          }
        }],
        line: 115
      },
      "15": {
        loc: {
          start: {
            line: 118,
            column: 12
          },
          end: {
            line: 118,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 118,
            column: 12
          },
          end: {
            line: 118,
            column: 15
          }
        }, {
          start: {
            line: 118,
            column: 19
          },
          end: {
            line: 118,
            column: 24
          }
        }],
        line: 118
      },
      "16": {
        loc: {
          start: {
            line: 119,
            column: 12
          },
          end: {
            line: 119,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 119,
            column: 12
          },
          end: {
            line: 119,
            column: 17
          }
        }, {
          start: {
            line: 119,
            column: 21
          },
          end: {
            line: 119,
            column: 32
          }
        }, {
          start: {
            line: 119,
            column: 36
          },
          end: {
            line: 119,
            column: 43
          }
        }],
        line: 119
      },
      "17": {
        loc: {
          start: {
            line: 120,
            column: 12
          },
          end: {
            line: 120,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 120,
            column: 12
          },
          end: {
            line: 120,
            column: 22
          }
        }, {
          start: {
            line: 120,
            column: 26
          },
          end: {
            line: 120,
            column: 36
          }
        }],
        line: 120
      },
      "18": {
        loc: {
          start: {
            line: 121,
            column: 12
          },
          end: {
            line: 121,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 121,
            column: 12
          },
          end: {
            line: 121,
            column: 27
          }
        }, {
          start: {
            line: 121,
            column: 31
          },
          end: {
            line: 121,
            column: 38
          }
        }],
        line: 121
      },
      "19": {
        loc: {
          start: {
            line: 123,
            column: 12
          },
          end: {
            line: 123,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 123,
            column: 12
          },
          end: {
            line: 123,
            column: 26
          }
        }, {
          start: {
            line: 123,
            column: 30
          },
          end: {
            line: 123,
            column: 38
          }
        }],
        line: 123
      },
      "20": {
        loc: {
          start: {
            line: 124,
            column: 12
          },
          end: {
            line: 124,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 124,
            column: 12
          },
          end: {
            line: 124,
            column: 19
          }
        }, {
          start: {
            line: 124,
            column: 23
          },
          end: {
            line: 124,
            column: 34
          }
        }],
        line: 124
      },
      "21": {
        loc: {
          start: {
            line: 125,
            column: 12
          },
          end: {
            line: 125,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 125,
            column: 12
          },
          end: {
            line: 125,
            column: 28
          }
        }, {
          start: {
            line: 125,
            column: 32
          },
          end: {
            line: 125,
            column: 62
          }
        }],
        line: 125
      },
      "22": {
        loc: {
          start: {
            line: 126,
            column: 12
          },
          end: {
            line: 126,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 126,
            column: 12
          },
          end: {
            line: 126,
            column: 17
          }
        }, {
          start: {
            line: 126,
            column: 21
          },
          end: {
            line: 126,
            column: 30
          }
        }],
        line: 126
      },
      "23": {
        loc: {
          start: {
            line: 127,
            column: 12
          },
          end: {
            line: 127,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 127,
            column: 12
          },
          end: {
            line: 127,
            column: 19
          }
        }, {
          start: {
            line: 127,
            column: 23
          },
          end: {
            line: 127,
            column: 28
          }
        }, {
          start: {
            line: 127,
            column: 32
          },
          end: {
            line: 127,
            column: 39
          }
        }],
        line: 127
      },
      "24": {
        loc: {
          start: {
            line: 128,
            column: 12
          },
          end: {
            line: 128,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 128,
            column: 12
          },
          end: {
            line: 128,
            column: 21
          }
        }, {
          start: {
            line: 128,
            column: 25
          },
          end: {
            line: 128,
            column: 36
          }
        }],
        line: 128
      },
      "25": {
        loc: {
          start: {
            line: 130,
            column: 22
          },
          end: {
            line: 130,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 130,
            column: 22
          },
          end: {
            line: 130,
            column: 37
          }
        }, {
          start: {
            line: 130,
            column: 41
          },
          end: {
            line: 130,
            column: 48
          }
        }],
        line: 130
      },
      "26": {
        loc: {
          start: {
            line: 130,
            column: 50
          },
          end: {
            line: 130,
            column: 115
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 130,
            column: 50
          },
          end: {
            line: 130,
            column: 74
          }
        }, {
          start: {
            line: 130,
            column: 78
          },
          end: {
            line: 130,
            column: 93
          }
        }, {
          start: {
            line: 130,
            column: 97
          },
          end: {
            line: 130,
            column: 115
          }
        }],
        line: 130
      },
      "27": {
        loc: {
          start: {
            line: 131,
            column: 10
          },
          end: {
            line: 131,
            column: 101
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 131,
            column: 52
          },
          end: {
            line: 131,
            column: 81
          }
        }, {
          start: {
            line: 131,
            column: 84
          },
          end: {
            line: 131,
            column: 101
          }
        }],
        line: 131
      },
      "28": {
        loc: {
          start: {
            line: 140,
            column: 22
          },
          end: {
            line: 140,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 140,
            column: 43
          },
          end: {
            line: 140,
            column: 44
          }
        }, {
          start: {
            line: 140,
            column: 47
          },
          end: {
            line: 140,
            column: 56
          }
        }],
        line: 140
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0, 0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0, 0],
      "27": [0, 0],
      "28": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/hoc/inputBorder.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { Component } from '../component';
import { curry } from '../utils/func';
import { popoverClass } from '../Popover/styles';
import { buttonClass } from '../Button/styles';
import { inputClass } from '../Input/styles';
import { inputBorderClass } from '../Form/styles';
import Popover from '../Popover';
import { isRTL } from '../config';
import getDataset from '../utils/dom/getDataset';
export default curry(function (options, Origin) {
  var _class, _temp;

  cov_tx9pssfxo.f[0]++;
  cov_tx9pssfxo.s[0]++;
  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inherits(_class, _Component);

    var _super = _createSuper2(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      cov_tx9pssfxo.f[1]++;
      cov_tx9pssfxo.s[1]++;
      _this = _super.call(this, props);
      _this.el = void 0;
      cov_tx9pssfxo.s[2]++;
      _this.el = null;
      cov_tx9pssfxo.s[3]++;
      _this.state = {
        focus: props.autoFocus
      };
      cov_tx9pssfxo.s[4]++;
      _this.bindRef = _this.bindRef.bind(_assertThisInitialized(_this));
      cov_tx9pssfxo.s[5]++;
      _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
      cov_tx9pssfxo.s[6]++;
      _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this)); // this.enterPress = this.enterPress.bind(this)

      return _this;
    }

    _createClass(_class, [{
      key: "bindRef",
      value: function bindRef(el) {
        cov_tx9pssfxo.f[2]++;
        cov_tx9pssfxo.s[7]++;
        this.el = el;
      }
    }, {
      key: "handleBlur",
      value: function handleBlur(event) {
        cov_tx9pssfxo.f[3]++;
        cov_tx9pssfxo.s[8]++;
        this.setState({
          focus: false
        });

        var _ref = (cov_tx9pssfxo.s[9]++, this.props),
            onBlur = _ref.onBlur;

        cov_tx9pssfxo.s[10]++;

        if (onBlur) {
          cov_tx9pssfxo.b[0][0]++;
          cov_tx9pssfxo.s[11]++;
          onBlur(event);
        } else {
          cov_tx9pssfxo.b[0][1]++;
        }
      }
    }, {
      key: "handleFocus",
      value: function handleFocus(event) {
        cov_tx9pssfxo.f[4]++;
        cov_tx9pssfxo.s[12]++;
        this.setState({
          focus: true
        });

        var _ref2 = (cov_tx9pssfxo.s[13]++, this.props),
            onFocus = _ref2.onFocus;

        cov_tx9pssfxo.s[14]++;

        if (onFocus) {
          cov_tx9pssfxo.b[1][0]++;
          cov_tx9pssfxo.s[15]++;
          onFocus(event);
        } else {
          cov_tx9pssfxo.b[1][1]++;
        }
      }
    }, {
      key: "renderHelp",
      value: function renderHelp(focus) {
        var _this2 = this;

        cov_tx9pssfxo.f[5]++;

        var _ref3 = (cov_tx9pssfxo.s[16]++, this.props),
            error = _ref3.error,
            tip = _ref3.tip,
            popover = _ref3.popover,
            _ref3$popoverProps = _ref3.popoverProps,
            popoverProps = _ref3$popoverProps === void 0 ? (cov_tx9pssfxo.b[2][0]++, {}) : _ref3$popoverProps;

        var classList = (cov_tx9pssfxo.s[17]++, ['input-tip']);
        var position = (cov_tx9pssfxo.s[18]++, (cov_tx9pssfxo.b[3][0]++, popover) || (cov_tx9pssfxo.b[3][1]++, isRTL() ? (cov_tx9pssfxo.b[4][0]++, 'bottom-right') : (cov_tx9pssfxo.b[4][1]++, 'bottom-left')));
        var styles = (cov_tx9pssfxo.s[19]++, (cov_tx9pssfxo.b[6][0]++, popoverProps.style) && (cov_tx9pssfxo.b[6][1]++, popoverProps.style.width) ? (cov_tx9pssfxo.b[5][0]++, popoverProps.style) : (cov_tx9pssfxo.b[5][1]++, Object.assign({
          minWidth: 200,
          maxWidth: 400
        }, (cov_tx9pssfxo.b[7][0]++, popoverProps.style) || (cov_tx9pssfxo.b[7][1]++, {})))); // 只有有错需要popover，或者tip被focus才显示

        cov_tx9pssfxo.s[20]++;

        if ((cov_tx9pssfxo.b[9][0]++, error) && (cov_tx9pssfxo.b[9][1]++, popover) || (cov_tx9pssfxo.b[9][2]++, tip) && (cov_tx9pssfxo.b[9][3]++, focus)) {
          cov_tx9pssfxo.b[8][0]++;
          cov_tx9pssfxo.s[21]++;

          if (error) {
            cov_tx9pssfxo.b[10][0]++;
            cov_tx9pssfxo.s[22]++;
            classList.push('input-error');
          } else {
            cov_tx9pssfxo.b[10][1]++;
          }

          cov_tx9pssfxo.s[23]++;
          return (
            /*#__PURE__*/
            React.createElement(Popover, Object.assign({
              getPopupContainer: function getPopupContainer() {
                cov_tx9pssfxo.f[6]++;
                cov_tx9pssfxo.s[24]++;
                return _this2.el;
              }
            }, popoverProps, {
              visible: true,
              style: styles,
              className: popoverClass.apply(void 0, classList),
              position: position,
              __self: this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 77,
                columnNumber: 13
              }
            }), error ? (cov_tx9pssfxo.b[11][0]++, error.message) : (cov_tx9pssfxo.b[11][1]++, tip))
          );
        } else {
          cov_tx9pssfxo.b[8][1]++;
        }

        cov_tx9pssfxo.s[25]++;
        return null;
      }
    }, {
      key: "render",
      value: function render() {
        cov_tx9pssfxo.f[7]++;

        var _ref4 = (cov_tx9pssfxo.s[26]++, this.props),
            className = _ref4.className,
            border = _ref4.border,
            size = _ref4.size,
            tip = _ref4.tip,
            popover = _ref4.popover,
            width = _ref4.width,
            style = _ref4.style,
            error = _ref4.error,
            popoverProps = _ref4.popoverProps,
            underline = _ref4.underline,
            other = _objectWithoutProperties(_ref4, ["className", "border", "size", "tip", "popover", "width", "style", "error", "popoverProps", "underline"]);

        var _ref5 = (cov_tx9pssfxo.s[27]++, this.state),
            focus = _ref5.focus;

        var rtl = (cov_tx9pssfxo.s[28]++, isRTL());
        var Tag = (cov_tx9pssfxo.s[29]++, (cov_tx9pssfxo.b[12][0]++, options.tag) || (cov_tx9pssfxo.b[12][1]++, 'label'));
        var newStyle = (cov_tx9pssfxo.s[30]++, Object.assign({
          width: width
        }, style));
        var isDisabled = (cov_tx9pssfxo.s[31]++, typeof other.disabled === 'function' ? (cov_tx9pssfxo.b[13][0]++, false) : (cov_tx9pssfxo.b[13][1]++, !!other.disabled));
        var newClassName = (cov_tx9pssfxo.s[32]++, classnames(inputBorderClass((cov_tx9pssfxo.b[14][0]++, rtl) && (cov_tx9pssfxo.b[14][1]++, 'rtl')), inputClass('_', (cov_tx9pssfxo.b[15][0]++, rtl) && (cov_tx9pssfxo.b[15][1]++, 'rtl'), (cov_tx9pssfxo.b[16][0]++, focus) && (cov_tx9pssfxo.b[16][1]++, !isDisabled) && (cov_tx9pssfxo.b[16][2]++, 'focus'), (cov_tx9pssfxo.b[17][0]++, isDisabled) && (cov_tx9pssfxo.b[17][1]++, 'disabled'), (cov_tx9pssfxo.b[18][0]++, options.isGroup) && (cov_tx9pssfxo.b[18][1]++, 'group'), size, (cov_tx9pssfxo.b[19][0]++, newStyle.width) && (cov_tx9pssfxo.b[19][1]++, 'inline'), (cov_tx9pssfxo.b[20][0]++, !border) && (cov_tx9pssfxo.b[20][1]++, 'no-border'), (cov_tx9pssfxo.b[21][0]++, options.overflow) && (cov_tx9pssfxo.b[21][1]++, "overflow-".concat(options.overflow)), (cov_tx9pssfxo.b[22][0]++, error) && (cov_tx9pssfxo.b[22][1]++, 'invalid'), (cov_tx9pssfxo.b[23][0]++, popover) && (cov_tx9pssfxo.b[23][1]++, error) && (cov_tx9pssfxo.b[23][2]++, 'focus'), (cov_tx9pssfxo.b[24][0]++, underline) && (cov_tx9pssfxo.b[24][1]++, 'underline')), buttonClass((cov_tx9pssfxo.b[25][0]++, options.isGroup) && (cov_tx9pssfxo.b[25][1]++, 'group'), (cov_tx9pssfxo.b[26][0]++, options.from === 'input') && (cov_tx9pssfxo.b[26][1]++, options.isGroup) && (cov_tx9pssfxo.b[26][2]++, 'from-input-group')), typeof options.className === 'function' ? (cov_tx9pssfxo.b[27][0]++, options.className(this.props)) : (cov_tx9pssfxo.b[27][1]++, options.className), this.props.className));
        cov_tx9pssfxo.s[33]++;
        return (
          /*#__PURE__*/
          React.createElement(Tag, Object.assign({
            ref: this.bindRef,
            className: newClassName,
            style: newStyle,
            tabIndex: options.enterPress ? (cov_tx9pssfxo.b[28][0]++, 0) : (cov_tx9pssfxo.b[28][1]++, undefined)
          }, getDataset(other), {
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 136,
              columnNumber: 11
            }
          }),
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, other, {
            size: size,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            inputFocus: focus,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 143,
              columnNumber: 13
            }
          })), this.renderHelp(focus))
        );
      }
    }]);

    return _class;
  }(Component), _class.defaultProps = {
    border: true,
    style: {},
    popoverProps: {}
  }, _temp;
});